import React, { Component } from "react";
import moment from 'moment';
import {
    VictoryChart,
    VictoryAxis,
    VictoryBrushContainer,
    VictoryLine,
    VictoryTooltip,
    VictoryTheme,
    VictoryArea,
    VictoryLabel,
    createContainer
} from "victory";



const VictoryZoomVoronoiContainer = createContainer("zoom", "voronoi");

class LargeStageChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            observedData: [],
            forecastData: [],
            totalData: [],
            tickValues: [],
            startDay: null,
            endDay: null,
            chartMax: 1,
            normal: 0,
            action: 0,
            minor: 0,
            moderate: 0,
            major: 0 
        };
    }


    // update chart domain based on user zoom action
    handleZoom(domain) {
        this.setState({ selectedDomain: domain });
    }

    // update chart domain based on user brush action
    handleBrush(domain) {
        this.setState({ zoomDomain: domain });
    }   

    
    componentDidMount() {

        // create formatted date object for observed
        const observed = this.props.data.map(p => {
            p.Date = moment(p.dateTime).format();
            p.Date = new Date(p.Date);
            return p;
        });

        // create formatted date object for observed
        const forecast = this.props.forecastData.map(p => {
            p.Date = moment(p.dateTime).format();
            p.Date = new Date(p.Date);
            return p;
        });

        // total readings
        const total = observed.concat(forecast);

        this.setState({ observedData: observed });
        this.setState({ forecastData: forecast });
        this.setState({ totalData: total });


        // set tick marks to occur daily from day of
        // first observed reading to last forecast reading
        const startDay = moment(total[0].Date);
        const endDay = moment(total[total.length - 1].Date);
        const timeline = endDay.diff(startDay, 'days');

        this.setState({ startDay, endDay });

        const newTickValues = []

        for (let i = 0; i < timeline; i++) {
            var newTickDay = moment(startDay).add(1, 'days')
            newTickValues.push(moment(newTickDay).format('MMM D'))

        }

        this.setState({ tickValues: newTickValues });


        // set flood levels
        const normal = 3;
        const action = 6;
        const minor = 10;
        const moderate = 12;
        const major = 16;
        const chartMax = major + 4;

        this.setState({ normal, action, minor, moderate, major, chartMax });

    }

    renderStageLabels = (stage) => {
        const stageValues = {
            3: "Normal",
            6: "Action 6ft",
            10: "Minor 10ft",
            12: "Moderate 12ft",
            16: "Major 16ft"
        }

        return stageValues[stage];
    }

    // return forecast or observed label for chart hover/tooltip
    renderVeronoiLabels = (datum) => {
        let dataObj = this.state.totalData.filter(reading => reading.Date === datum.Date);
        dataObj = dataObj[0];
        let label = '';
        if (moment(datum._x).isBefore() && dataObj) {
            label = `Observed Stage: ${dataObj.value} ft \n ${moment(datum._x).format('lll')}`;
        } else if (!moment(datum._x).isBefore() && dataObj) {
            label = `Forecast Stage: ${dataObj.value} ft \n ${moment(datum._x).format('lll')}`;
        }
        return label;
    }


    render() {

        return (
            <div class="chartWrapper">
                <VictoryChart
                    padding={{ top: 15, left: 75, right: 50, bottom: 10 }}
                    width={700}
                    height={60}
                    scale={{ x: "time" }}
                    containerComponent={
                        <VictoryBrushContainer
                            //responsive={false}
                            brushDimension="x"
                            brushDomain={this.state.selectedDomain}
                            onBrushDomainChange={this.handleBrush.bind(this)}
                            brushStyle={{ stroke: "transparent", fill: "#369de0", fillOpacity: 0.2 }}
                        />
                    }
                >
                    <VictoryAxis dependentAxis
                        domain={[0, this.state.chartMax]}
                        orientation="left"
                        standalone={false}
                        tickValues={[0, this.state.chartMax]}
                        style={{
                            axis: { stroke: "#756f6a" },
                            axisLabel: { fontSize: 20, padding: 30 },
                            grid: { stroke: "grey" },
                            ticks: { stroke: "grey", size: 5 },
                            tickLabels: { fontSize: 0, padding: 5 }
                        }}
                    />

                    <VictoryLine
                        style={{
                            data: { stroke: "gray" }
                        }}
                        data={this.state.totalData}
                        x="Date"
                        y={"value"}
                    />
                </VictoryChart>
                <p className="dragMessage">Click and drag the edges or position of blue brush container to zoom to or select data ranges</p>

                <VictoryChart
                    padding={{ top: 5, left: 75, right: 50, bottom: 60 }}
                    width={700}
                    height={350}
                    scale={{ x: "time" }}
                    theme={VictoryTheme.material}
                    containerComponent={
                        <VictoryZoomVoronoiContainer
                            //responsive={false}
                            zoomDimension="x"
                            zoomDomain={this.state.zoomDomain}
                            onZoomDomainChange={this.handleZoom.bind(this)}
                            labelComponent={<VictoryTooltip constrainToVisibleArea pointerLength={0} cornerRadius={0} flyoutStyle={{ fill: "white" }} />}
                            labels={({ datum }) => this.renderVeronoiLabels(datum)}
                        />
                    }
                >
                    <VictoryAxis dependentAxis
                        domain={[0, this.state.chartMax]}
                        orientation="left"
                        standalone={false}
                        tickFormat={(t) => `${Math.round(t)} ft`}
                        label="River Stage (ft)"
                        axisLabelComponent={<VictoryLabel dy={-45} />}

                    />
                    <VictoryAxis dependentAxis
                        domain={[0, this.state.chartMax]}
                        orientation="left"
                        standalone={false}
                        tickValues={[this.state.normal, this.state.action, this.state.minor, this.state.moderate, this.state.major]}
                        tickFormat={(t) => `${this.renderStageLabels(t)}`}
                        tickLabelComponent={<VictoryLabel x={83} textAnchor="start" />}
                        style={{
                            axis: { stroke: "#756f6a", strokeWidth: "0" },
                            axisLabel: { fontSize: 20, padding: 30 },
                            ticks: { stroke: "grey", size: 0 },
                            tickLabels: { fontSize: 10, padding: 0, align: "center" }
                        }}
                    />
                    <VictoryAxis
                        scale="time"
                        label="Site Date/Time (EST)"
                        axisLabelComponent={<VictoryLabel dy={35} />}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#00CC33", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.normal, y0: 0 },
                            { x: this.state.endDay, y: this.state.normal, y0: 0 }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#00CC33", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.action, y0: this.state.normal },
                            { x: this.state.endDay, y: this.state.action, y0: this.state.normal }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#FFCC00", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.minor, y0: this.state.action },
                            { x: this.state.endDay, y: this.state.minor, y0: this.state.action }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#FF8700", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.moderate, y0: this.state.minor },
                            { x: this.state.endDay, y: this.state.moderate, y0: this.state.minor }
                        ]}
                    />

                    <VictoryArea
                        style={{ data: { fill: "#FF0000", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.major, y0: this.state.moderate },
                            { x: this.state.endDay, y: this.state.major, y0: this.state.moderate }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#9900FF", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.chartMax, y0: this.state.major },
                            { x: this.state.endDay, y: this.state.chartMax, y0: this.state.major }
                        ]}
                    />
                    <VictoryArea
                        style={{
                            data: { fillOpacity: 0.4, stroke: "#3366cc", fill: "#ffffff" }
                        }}
                        data={this.state.observedData}
                        x="Date"
                        y={"value"}
                    />
                    <VictoryArea
                        style={{
                            data: { fillOpacity: 0.4, stroke: "#3366cc", fill: "#555555" }
                        }}
                        data={this.state.forecastData}
                        x="Date"
                        y={"value"}
                    />


                </VictoryChart>
            </div>
        );
    }
}

export default LargeStageChart;



// WEBPACK FOOTER //
// ./src/components/LargeStageChart/index.js